/**
 * Created by nijin on 14/2/17.
 */
import {Injectable, EventEmitter, Optional, SkipSelf} from '@angular/core';

import { Notification } from './index';

/**
 * A service to create notification, It can be used from any component or guard
 */
@Injectable()
export class NotificationBarService {
  onCreate = new EventEmitter<Notification>();

  constructor(@Optional() @SkipSelf() prior: NotificationBarService) {
    if (prior) { return prior; }
  }

  create(notification: Notification) {
    this.onCreate.emit(notification);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/notify/notification.service.ts